module.exports = __webpack_public_path__ + "static/casa-de-papel-66d773f71011abd2314b63732218df02.png";